export const dragStartIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.25 18.003h19.5m-19.5-6h19.5m-19.5-6h19.5" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px"/></svg>`,
    name: 'drag-start'
};